/**
 * Settings & Profile Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines settings, profile, and help routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const SettingsPage = lazy(() => import('@/features/settings/ui/pages/settings-page'));
const HelpPage = lazy(() => import('@/features/help/ui/pages/help-page'));

export const settingsRoutes: RouteGroup = {
  name: 'settings',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.SETTINGS,
      component: SettingsPage,
      meta: {
        title: 'common:nav.settings',
        icon: 'CogIcon',
        showInNav: true,
        navOrder: 8,
      },
    },
    {
      path: ROUTE_PATHS.PROFILE,
      component: SettingsPage,
      meta: {
        title: 'common:nav.profile',
        icon: 'UserCircleIcon',
        showInNav: true,
        navOrder: 9,
      },
    },
    {
      path: ROUTE_PATHS.HELP,
      component: HelpPage,
      meta: {
        title: 'common:nav.help',
        icon: 'QuestionMarkCircleIcon',
        showInNav: true,
        navOrder: 10,
      },
    },
  ],
};
